<script setup lang="ts">
import ConfirmPopup from 'primevue/confirmpopup';
import ConfirmDialog from 'primevue/confirmdialog';
import Toast from 'primevue/toast';
import { useToast } from 'primevue/usetoast';
// import { VueQueryDevtools } from '@tanstack/vue-query-devtools';
import { useIdle } from '@vueuse/core';
import LoadingOverlay from './LoadingOverlay.vue';
import { watchErrorToasts } from './utils/errors';

const toast = useToast();
watchErrorToasts(toast);

const { idle } = useIdle(60 * 60 * 1000); // 1h idle check
watch(idle, (current, old) => {
  if (old === true && current === false) {
    console.info('Reload because > 30min idle');
    window.location.reload();
  }
});
</script>

<template>
  <LoadingOverlay />


  <router-view v-slot="{ Component, route }">
    <component v-if="['login', 'register', 'forgottenPass', 'passReset'].includes((route.name ?? '').toString())"
      :is="Component" />

    <MainPageFlow v-else>
      <component :is="Component" />
    </MainPageFlow>
  </router-view>

  <Toast />
  <ConfirmPopup />
  <ConfirmDialog group="dialog" :draggable="false" />
  <!-- <VueQueryDevtools /> -->
  <OrderFormDialog />
</template>
